var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ListingTemplate',{scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('h1',[_vm._v(_vm._s(_vm.role_name))]),_c('hr'),_c('PermissionList',{attrs:{"permissionDetail":_vm.permissionDetail}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }